import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const { TOGGLE_ACTIVE, PURPLE } = colors;
import { Bogle_Regular } from 'constants/constant';

const dashboardStyles = makeStyles(() => ({
	bannerContainer: {
		width: '100%',
		height: '40px',
		background: TOGGLE_ACTIVE,
		position: 'relative',
		zIndex: 10
	},
	textContainer: {
		display: 'flex',
		paddingTop: '9px',
		paddingBottom: '9px',
		alignContent: 'center',
		justifyContent: 'center'
	},
	regularText: {
		display: 'inline-block',
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: 'normal',
		paddingRight: '2.5px'
	},
	boldText: {
		display: 'inline-block',
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 700,
		lineHeight: 'normal',
		paddingRight: '2.5px'
	},
	underlineText: {
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: 400,
		lineHeight: 'normal',
		textDecorationLine: 'underline',
		zIndex: 11,
		'&:hover': {
			cursor: 'pointer'
		}
	}
}));

export default dashboardStyles;
